export default (lessonTitle) => {
  return {
    lesson: 1000,
    title: lessonTitle
  }
}
